import React, { Component } from 'react';
import { Document, Font, Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer';
import {
  WatchlistBaseModel,
  WatchlistEntityRequest,
  WatchlistGeneralRequest,
  WatchlistIndividualRecord,
  WatchlistIndividualRequest,
  WatchlistListsModel,
} from '../../../../domain/watchlist/WatchlistDomains';
import { WatchlistType } from '../../../../constant/Constants';
import _ from 'lodash';
import WatchlistReportInformationComponent from './WatchlistReportInformationComponent';
import moment from 'moment/moment';
import WatchlistService from '../../../../service/WatchlistService';
import ServiceContainer from '../../../../config/ServiceContainer';
import { ServiceNames } from '../../../../constant/ServiceNames';
import LanguageUtil from '../../../../util/LanguageUtil';

class WatchlistReportComponent extends Component<Props, State> {
  public state: State = new State();
  private watchlistService: WatchlistService = ServiceContainer.getInstance().get(ServiceNames.WATCHLIST);

  render() {
    const { selectedResponse, watchlistResponse, type } = this.props;
    const styles = StyleSheet.create({
      page: {
        flexDirection: 'column',
        fontFamily: 'Arial',
      },
    });
    Font.register({
      family: 'Arial',
      fonts: [{ src: '/font/arial.ttf' }],
    });

    return (
      <Document pageLayout={'singlePage'} pageMode={'fullScreen'}>
        <Page size={'A4'} wrap={false} style={styles.page}>
          <Image src={'/kyc-template.png'} style={{ height: '100%', width: '100%' }} />
          <View style={{ padding: '0 30px 30px 30px', display: 'flex', flexDirection: 'column' }}>
            {this.getHeader()}
            {this.getSearchCriteria()}
            <WatchlistReportInformationComponent selectedResponse={selectedResponse} watchlistResponse={watchlistResponse} type={type} />
          </View>
          <View style={{ padding: '30px', display: 'flex', flexDirection: 'column' }}>
            <Text style={{ fontSize: '10px', color: '#444444' }}>
              {LanguageUtil.get({
                id: 'pages.watchlist.pdfReportComponent.description',
                defaultMessage: '*This document is a PDF output of the alert triggered by the Formica KYC.',
              })}
            </Text>
            <View style={{ display: 'flex', flexDirection: 'row', paddingTop: '10px', alignItems: 'center', justifyContent: 'space-between' }}>
              <Text style={{ color: '#888888', fontSize: '10px' }}>
                {LanguageUtil.get({ id: 'pages.watchlist.pdfReportComponent.formica', defaultMessage: 'Formica Risk Orchestration Platform / AML&KYC' })}
              </Text>
              <Image src={'/kyc/logo.png'} style={{ height: '16px', width: '70px' }} />
            </View>
          </View>
        </Page>
      </Document>
    );
  }

  public async componentDidMount() {
    const { selectedResponse, type } = this.props;
    const images = selectedResponse?.record?.records?.filter(
      (record) => (record.watchlistRecord as WatchlistIndividualRecord).images && (record.watchlistRecord as WatchlistIndividualRecord).images.length > 0,
    );
    if (type == 'Individual' && images != undefined && images.length > 0) {
      const imageRes = await this.watchlistService.imageConvertBase64((images[0].watchlistRecord as WatchlistIndividualRecord).images[0].toString());
      this.setState({
        imageUrl: imageRes,
      });
    }
  }

  private getHeader = () => {
    const { selectedResponse, name } = this.props;
    return (
      <View style={{ display: 'flex', flexDirection: 'row', gap: '12px' }}>
        {this.state.imageUrl && this.getImage()}
        <View style={{ display: 'flex', flexDirection: 'column', gap: '4px', justifyContent: 'center' }}>
          <Text>{name || LanguageUtil.get({ id: 'pages.watchlist.pdfReportComponent.nameUndefined', defaultMessage: 'Name Undefined' })}</Text>
          <View style={{ display: 'flex', flexDirection: 'row', alignItems: 'center', gap: '4px' }}>
            <Text
              style={{
                color: '#027A48',
                backgroundColor: '#DBFFEA',
                fontSize: '10px',
                paddingHorizontal: '16px',
                paddingVertical: '2px',
                borderRadius: 50,
              }}
            >
              {selectedResponse?.score || 0}/100
            </Text>
            {this.getCategory()?.map((value: string, index: number) => {
              return (
                <Text
                  key={index}
                  style={{
                    color: '#4F4F4F',
                    backgroundColor: '#F6F6F9',
                    fontSize: '10px',
                    paddingHorizontal: '16px',
                    paddingVertical: '2px',
                    borderRadius: 50,
                  }}
                >
                  {value}
                </Text>
              );
            })}
            <Text
              style={{
                color: '#4F4F4F',
                backgroundColor: '#F6F6F9',
                fontSize: '10px',
                paddingHorizontal: '16px',
                paddingVertical: '2px',
                borderRadius: 50,
              }}
            >
              {moment().format('DD/MM/yyyy HH:mm').valueOf()}
            </Text>
          </View>
        </View>
      </View>
    );
  };

  private getSearchCriteria = () => {
    const { request } = this.props;
    if (request == undefined) return;
    return (
      <View style={{ paddingTop: '12px' }}>
        <View style={{ width: '100%', borderBottom: '1px solid #DDDDDD', gap: '2px' }}>
          <Text style={{ color: '#284564', fontSize: '14px' }}>
            {LanguageUtil.get({ id: 'common.label.searchCriteria', defaultMessage: 'Search Criteria' })}
          </Text>
          <Text style={{ color: '#888888', fontSize: '10px', paddingBottom: '2px' }}>
            {LanguageUtil.get({ id: 'common.label.searchCriteriaDescription', defaultMessage: 'Search criteria entered to scan in the lists' })}
          </Text>
        </View>
        {Object.entries(request).map((data, index) => {
          return (
            <View
              style={{
                display: 'flex',
                flexDirection: 'row',
                justifyContent: 'space-between',
                borderBottom: '1px solid #DDDDDD',
                paddingVertical: '8px',
              }}
              key={index}
            >
              <Text style={{ width: '20%', fontSize: '11px', color: 'black' }}>{this.formatToName(data[0])}</Text>
              <Text style={{ width: '80%', fontSize: '11px', color: '#4F4F4F' }}>{Array.isArray(data[1]) ? data[1].join(',') : data[1]}</Text>
            </View>
          );
        })}
      </View>
    );
  };

  private formatToName(inputString: string) {
    if (inputString === 'referenceId') {
      return LanguageUtil.get({ id: 'common.label.referenceId', defaultMessage: 'Reference ID' });
    }
    return inputString.replace(/([a-z])([A-Z])/g, '$1 $2').replace(/^./, function (str) {
      return str.toUpperCase();
    });
  }

  private getCategory = () => {
    const { selectedResponse } = this.props;
    if (selectedResponse == undefined || selectedResponse.record == undefined) return;
    const categories: any[] = [];
    selectedResponse.record?.records?.forEach((response) => {
      categories.push(response.watchlistRecord.categories);
    });
    return _.uniqBy([].concat(...categories));
  };

  private getImage = () => {
    const { selectedResponse, type } = this.props;
    const { imageUrl } = this.state;
    const images = selectedResponse?.record?.records?.filter(
      (record) => (record.watchlistRecord as WatchlistIndividualRecord).images && (record.watchlistRecord as WatchlistIndividualRecord).images.length > 0,
    );
    if (type == 'Individual' && images != undefined && images.length > 0) {
      return <Image source={imageUrl} style={{ height: 60, width: 60, border: '1px solid', borderRadius: '50px' }} />;
    } else {
      return <Text style={{ height: 60, width: 60, border: '1px solid', borderRadius: '50px', backgroundColor: '#EFF2FE' }} />;
    }
  };
}

interface Props {
  selectedResponse: WatchlistBaseModel | undefined;
  request: WatchlistIndividualRequest | WatchlistEntityRequest | WatchlistGeneralRequest | undefined;
  watchlistResponse: WatchlistListsModel[];
  type: WatchlistType | undefined;
  name: string | undefined | null;
}

class State {
  imageUrl: string | undefined;
}

export default WatchlistReportComponent;
